export const CATALOG_ROUTE = 'Catalog'
export const CHECKOUT_ROUTE = 'Checkout'
export const DEFAULT_ROUTE = 'DefaultRoute'
export const DIRECT_PAYMENTS_ROUTE = 'DirectPayments'
export const DIRECT_PAYMENTS_ACH_ROUTE = 'ACHDirectPayments'
export const DIRECT_PAYMENTS_DEBIT_CARD_ROUTE = 'DebitCardDirectPayments'
export const ERROR_ROUTE = 'Error'
export const ORDER_COMPLETE_ROUTE = 'Complete'
export const PASSWORD_RESET_ROUTE = 'PasswordReset'
export const REDEMPTION_HISTORY_ROUTE = 'RedemptionHistory'
export const REVIEW_AND_COMPLETE_ROUTE = 'ReviewAndComplete'
export const SURVEY_ROUTE = 'Survey'
export const WALLET_DASHBOARD = 'WalletDashboard'
export const WALLET_FORGOT_ROUTE = 'PasswordForgot'
export const WALLET_LOGIN_ROUTE = 'WalletLogin'
export const WALLET_ROUTE = 'Wallet'
export const WALLET_REGISTER_ROUTE = 'WalletRegister'
export const WALLET_SETTINGS_ROUTE = 'WalletSettings'
